// Module
var code = "<ng-include ng-if=\"!viewConfig.hideListHeader\" src=\"'common/listHeaderColumns-xs.tpl.html'\"></ng-include>\n";
// Exports
module.exports = code;